import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Container } from 'reactstrap';

import SupportEntry from './SupportEntry';
import {
  findingSupportFieldsSelector,
  resolutionOptionsSelector,
} from '../../../selectors/findingsSelectors';

/*
Constants and helpers
*/

const getCompositeStr = ({
  rawValue,
  valueStr,
}) => valueStr
  ? `${rawValue} (${valueStr})`
  : rawValue;

const getJurisdiction = ({
  findingPropsList,
  rawValue,
}) => {
  const jurisdictionName = findingPropsList
    .find(elt => elt.key === 'jurisdictionName');

  const { value: valueStr = '' } = jurisdictionName || {};

  const value = getCompositeStr({
    rawValue,
    valueStr,
  });

  return value;
};

const getResolution = ({
  resolutionOptions,
  rawValue,
}) => {
  const option = resolutionOptions
    .find(elt => elt.value === rawValue);

  const { label: valueStr = '' } = option || {};

  const value = getCompositeStr({
    rawValue,
    valueStr,
  });

  return value;
};


// Returns the property value formatted as a string for use in SupportEntry
const formatValue = ({
  findingPropsList,
  key,
  resolutionOptions,
  rawValue,
}) => {
  if (key === 'resolution') {
    return getResolution({
      resolutionOptions,
      rawValue,
    });
  }

  if (key === 'jurisdiction') {
    return getJurisdiction({
      findingPropsList,
      rawValue,
    });
  }

  return rawValue;
};

// Returns SupportEntry constructed from the passed-in props
const SupportEntryWrapper = ({
  elt,
  findingPropsList,
  index,
  resolutionOptions,
}) => {
  const {
    key,
    label = '',
    value: rawValue,
  } = elt;

  const value = formatValue({
    findingPropsList,
    key,
    resolutionOptions,
    rawValue,
  });

  return (
    <SupportEntry
      key={index}
      label={label}
      value={value}
    />
  );
};

SupportEntryWrapper.propTypes = {
  elt: PropTypes.shape({}).isRequired,
  findingPropsList: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
  resolutionOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

/*
Component
*/

const FindingSupportDetail = (props) => {
  const {
    findingPropsList,
    resolutionOptions,
  } = props;

  return (
    <Container className="list-container dark" fluid>
      {findingPropsList
        .filter(elt => elt.display)
        .map((elt, index) => SupportEntryWrapper({
          elt,
          findingPropsList,
          index,
          resolutionOptions,
        }))}
    </Container>
  );
};

FindingSupportDetail.propTypes = {
  findingPropsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  resolutionOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = (state) => {
  const findingPropsList = findingSupportFieldsSelector(state);
  const resolutionOptions = resolutionOptionsSelector(state);

  return ({
    findingPropsList,
    resolutionOptions,
  });
};


export default connect(mapStateToProps, null)(FindingSupportDetail);
